$(document).ready(function() {
  console.log("=== QUANTITY OFFERS - VERSIÓN CON SELECTOR DE CANTIDAD ===");

  let selectedQuantity = 1;
  let productVariants = [];
  let isProcessing = false;
  let offerSelections = {}; // Tracking de selecciones por oferta
  let offerCartItems = []; // Items agregados al carrito por ofertas

  // ========================================
  // SOLO DETECCIÓN DE CIERRE RSI (SIN TOCAR ESTILOS)
  // ========================================

  // Función MÍNIMA para detectar cierre RSI y limpiar carrito
  function setupMinimalRSIDetection() {
    console.log("Configurando detección mínima de RSI...");
    
    let rsiWasOpen = false;
    
    // Observer SOLO para detectar apertura/cierre del modal
    const observer = new MutationObserver((mutations) => {
      const rsiDialog = document.getElementById('rsi_form_wrapper');
      
      if (rsiDialog) {
        const isCurrentlyOpen = rsiDialog.hasAttribute('open');
        
        // Solo registrar cambios de estado sin interferir
        if (isCurrentlyOpen && !rsiWasOpen) {
          console.log("RSI abierto - esperando cierre para limpiar...");
          rsiWasOpen = true;
        }
        
        if (!isCurrentlyOpen && rsiWasOpen) {
          console.log("RSI cerrado - limpiando ofertas del carrito...");
          setTimeout(() => {
            clearAllOffers().then(() => {
              // Resetear estado
              selectedQuantity = 1;
              isProcessing = false;
              $('input[name="quantity_offer"]').prop('checked', false);
              $('#variantSelector2, #variantSelector3').hide();
              
              // NUEVO: Resetear cantidad a 1
              $('.qty, input[name="quantity"]').val(1);
              
              // Restaurar botones
              $('.product-form__add-button, .btn-primary-buy').each(function() {
                $(this).prop('disabled', false);
                const originalText = $(this).data('original-text');
                if (originalText) {
                  $(this).text(originalText);
                }
              });
              
              $('#loader').hide();
              console.log("Limpieza de ofertas completada y cantidad reseteada a 1");
            });
          }, 300);
          rsiWasOpen = false;
        }
      }
    });
    
    // Observer MÍNIMO - solo para detectar el modal, sin atributos de estilo
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'] // SOLO el atributo open, nada de style
    });
    
    // Event listener simple para botón cerrar
    $(document).on('click', '.rsi-form-close-button', function() {
      console.log("Botón cerrar RSI clickeado - programando limpieza...");
      setTimeout(() => {
        clearAllOffers();
        selectedQuantity = 1;
        isProcessing = false;
        $('input[name="quantity_offer"]').prop('checked', false);
        $('#variantSelector2, #variantSelector3').hide();
        $('.qty, input[name="quantity"]').val(1); // Resetear cantidad
      }, 300);
    });
  }

  // ========================================
  // FUNCIONES PRINCIPALES
  // ========================================

  // Cargar datos del producto desde el JSON embebido
  function loadProductData() {
    try {
      const productJSON = $('[data-product-json]');
      if (productJSON.length) {
        const data = JSON.parse(productJSON.html());
        productVariants = data.product.variants || [];
        console.log("Variantes cargadas desde JSON del tema:", productVariants.length);
        return true;
      }
    } catch (e) {
      console.error("Error parseando JSON del tema:", e);
    }

    // Fallback a variables globales
    if (typeof window.product !== 'undefined' && window.product.variants) {
      productVariants = window.product.variants;
      console.log("Variantes desde window.product:", productVariants.length);
      return true;
    }

    return false;
  }

  // Detectar si el producto tiene variantes reales
  function hasRealVariants() {
    // Verificar si existen selectores de variantes visibles en el DOM
    const hasVariantSelectors = $('.product-form__single-selector, .variant-selector, [data-variant-selector]').length > 0;
    const hasOptionSelectors = $('input[type="radio"][name*="option"], select[name*="option"]').length > 0;
    
    console.log("Selectores de variantes encontrados:", hasVariantSelectors);
    console.log("Selectores de opciones encontrados:", hasOptionSelectors);
    
    return hasVariantSelectors || hasOptionSelectors;
  }

  // Obtener variante actualmente seleccionada (usando el sistema del tema)
  function getCurrentVariantId() {
    const $variantInput = $('input[name="id"]');
    if ($variantInput.length && $variantInput.val()) {
      return $variantInput.val();
    }

    if (productVariants.length > 0) {
      const availableVariant = productVariants.find(v => v.available) || productVariants[0];
      return availableVariant.id.toString();
    }
    
    return null;
  }

  // Agregar producto al carrito de forma invisible
  function addToCartSilent(variantId, quantity = 1) {
    console.log("Agregando silenciosamente variante:", variantId, "cantidad:", quantity);
    
    return $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        id: parseInt(variantId),
        quantity: quantity
      })
    }).done(function(data) {
      console.log("Variante agregada silenciosamente:", data);
      updateCartCounter();
    }).fail(function(xhr) {
      console.error("Error agregando variante silenciosamente:", xhr.responseText);
    });
  }

  // Eliminar producto del carrito
  function removeFromCartSilent(variantId) {
    console.log("Eliminando silenciosamente variante:", variantId);
    
    return $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        updates: {
          [variantId]: 0
        }
      })
    }).done(function(data) {
      console.log("Variante eliminada silenciosamente del carrito");
      updateCartCounter();
    }).fail(function(xhr) {
      console.error("Error eliminando variante:", xhr.responseText);
    });
  }

  // Actualizar contador del carrito
  function updateCartCounter() {
    $.get('/cart.js').done(function(cart) {
      $('.cart-count, .cart-counter, [data-cart-count]').text(cart.item_count);
    });
  }

  // Encontrar variante por opciones seleccionadas
  function findVariantByOptions(option1, option2, option3) {
    console.log("Buscando variante con opciones:", { option1, option2, option3 });
    
    const variant = productVariants.find(v => {
      const match1 = !option1 || v.option1 === option1;
      const match2 = !option2 || v.option2 === option2; 
      const match3 = !option3 || v.option3 === option3;
      return match1 && match2 && match3;
    });
    
    if (variant) {
      console.log("Variante encontrada:", variant.id, "-", variant.title);
      return variant.id.toString();
    } else {
      console.warn("No se encontró variante para las opciones especificadas");
      return null;
    }
  }

  // Obtener opciones seleccionadas para un producto específico
  function getSelectedOptionsForProduct(productPosition) {
    const options = {};
    
    // Buscar todos los inputs checked para este producto
    $(`input[data-product-position="${productPosition}"]:checked`).each(function() {
      const $input = $(this);
      const optionPosition = $input.attr('data-option-position');
      const value = $input.val();
      
      options[`option${optionPosition}`] = value;
      console.log(`Opción ${optionPosition} para producto ${productPosition}:`, value);
    });
    
    return options;
  }

  // Procesar selección de producto en oferta
  function processOfferProductSelection(productPosition) {
    console.log("Procesando selección para producto:", productPosition);
    
    const options = getSelectedOptionsForProduct(productPosition);
    
    // Verificar si tenemos todas las opciones necesarias
    const optionCount = Object.keys(options).length;
    const totalOptions = productVariants.length > 0 ? 
      (productVariants[0].option3 ? 3 : productVariants[0].option2 ? 2 : 1) : 1;
    
    if (optionCount < totalOptions) {
      console.log("Esperando más selecciones...", optionCount, "de", totalOptions);
      return; // Esperamos a que se seleccionen todas las opciones
    }
    
    // Buscar la variante correspondiente
    const variantId = findVariantByOptions(
      options.option1, 
      options.option2, 
      options.option3
    );
    
    if (variantId) {
      handleOfferVariantSelection(productPosition, variantId);
    }
  }

  // Manejar selección de variante en oferta
  function handleOfferVariantSelection(productPosition, variantId) {
    console.log(`SELECCIÓN en producto ${productPosition}: ${variantId}`);

    // Si había una selección anterior, eliminarla del carrito
    if (offerSelections[productPosition]) {
      const previousVariant = offerSelections[productPosition];
      console.log(`Eliminando variante anterior del producto ${productPosition}:`, previousVariant);
      removeFromCartSilent(previousVariant);
      // Remover de tracking
      offerCartItems = offerCartItems.filter(id => id !== previousVariant);
    }

    // Guardar nueva selección
    offerSelections[productPosition] = variantId;

    // Agregar nueva variante al carrito
    addToCartSilent(variantId).done(function() {
      // Agregar a tracking
      offerCartItems.push(variantId);
      console.log(`Nueva variante agregada para producto ${productPosition}:`, variantId);
    });
  }

  // Limpiar todas las ofertas del carrito
  function clearAllOffers() {
    console.log("Limpiando todas las ofertas del carrito:", offerCartItems);
    
    const promises = offerCartItems.map(variantId => removeFromCartSilent(variantId));
    
    return Promise.all(promises).then(() => {
      // Resetear tracking
      offerCartItems = [];
      offerSelections = {};
      
      // Resetear todos los inputs de opciones
      $('input.option-input').prop('checked', false);
      
      console.log("Todas las ofertas eliminadas y estado reseteado");
    }).catch(() => {
      // Si hay error, al menos resetear el estado local
      offerCartItems = [];
      offerSelections = {};
      $('input.option-input').prop('checked', false);
      console.log("Error limpiando carrito, pero estado local reseteado");
    });
  }

  // NUEVA: Función para actualizar cantidad en el selector
  function updateQuantitySelector(quantity) {
    console.log(`📊 Actualizando selector de cantidad a: ${quantity}`);
    
    // Buscar todos los posibles inputs de cantidad
    const $qtyInputs = $('.qty, input[name="quantity"], .product-form__quantity input, [data-quantity-input]');
    
    if ($qtyInputs.length > 0) {
      $qtyInputs.val(quantity);
      console.log(`✅ Cantidad actualizada a ${quantity} en ${$qtyInputs.length} inputs`);
      
      // Disparar evento change para notificar al tema
      $qtyInputs.trigger('change');
      
      return true;
    } else {
      console.warn("⚠️ No se encontraron inputs de cantidad");
      return false;
    }
  }

  // Detectar si es Releasit con nuevos identificadores RSI
  function isReleasitForm() {
    return typeof window.RELEASIT !== 'undefined' || 
           typeof window.ReleasitCOD !== 'undefined' ||
           $('[data-releasit]').length > 0 || 
           $('[data-releasit-cod]').length > 0 ||
           $('.releasit-cod-form').length > 0 ||
           $('.releasit-form').length > 0 ||
           $('#releasit-cod-modal').length > 0 ||
           $('#rsi_form_wrapper').length > 0 ||
           $('[class*="rsi-"]').length > 0 ||
           $('[id*="releasit"]').length > 0;
  }

  // NUEVA: Procesar compra con cantidad múltiple (versión simplificada)
  function processQuantityPurchase(quantity) {
    if (isProcessing) {
      console.log("Ya hay un proceso en curso");
      return;
    }
    
    isProcessing = true;
    console.log("=== PROCESANDO COMPRA CON CANTIDAD MÚLTIPLE ===");
    console.log("Cantidad solicitada:", quantity);
    console.log("Tiene variantes reales:", hasRealVariants());

    try {
      // Verificar si el producto tiene variantes reales
      if (!hasRealVariants()) {
        // PRODUCTO SIN VARIANTES: Usar selector de cantidad
        console.log("🔢 PRODUCTO SIN VARIANTES - Usando selector de cantidad");
        
        const success = updateQuantitySelector(quantity);
        if (success) {
          console.log("✅ Cantidad actualizada, permitiendo envío normal del formulario");
          isProcessing = false;
          return; // Permitir que el formulario se envíe normalmente
        } else {
          throw new Error("No se pudo actualizar el selector de cantidad");
        }
        
      } else {
        // PRODUCTO CON VARIANTES: Usar lógica original
        console.log("📦 PRODUCTO CON VARIANTES - Verificando selecciones...");
        
        // Verificar que se hayan seleccionado todas las variantes necesarias
        const requiredSelections = [];
        if (quantity >= 2) requiredSelections.push('2');
        if (quantity >= 3) {
          requiredSelections.push('3_2', '3');
        }
        
        const missingSelections = requiredSelections.filter(pos => !offerSelections[pos]);
        if (missingSelections.length > 0) {
          throw new Error(`Faltan selecciones para: ${missingSelections.join(', ')}`);
        }
        
        // Preparar variantes para compra múltiple
        const variants = [getCurrentVariantId()];
        if (quantity >= 2 && offerSelections['2']) {
          variants.push(offerSelections['2']);
        }
        if (quantity >= 3) {
          if (offerSelections['3_2']) variants.push(offerSelections['3_2']);
          if (offerSelections['3']) variants.push(offerSelections['3']);
        }
        
        console.log("Variantes preparadas:", variants);
        
        // Procesar según el sistema
        if (isReleasitForm()) {
          console.log("🚀 Usando sistema Releasit/RSI para variantes");
          return processVariantsForReleasit(variants);
        } else {
          console.log("🛒 Usando sistema Shopify para variantes");
          return processVariantsForShopify(variants);
        }
      }

    } catch (error) {
      console.error("❌ Error en compra múltiple:", error);
      alert("Error: " + error.message);
      isProcessing = false;
      throw error;
    }
  }

  // Procesar variantes para Releasit
  function processVariantsForReleasit(variants) {
    const $mainForm = $('.product-form');
    if (!$mainForm.length) {
      throw new Error("No se encontró formulario del producto");
    }

    return clearAllOffers().then(() => {
      const $tempForm = $mainForm.clone();
      $tempForm.attr('id', 'quantity-offers-releasit-form');
      $tempForm.hide();

      // Establecer variante principal
      $tempForm.find('input[name="id"]').val(variants[0]);
      $tempForm.find('.qty, input[name="quantity"]').val(1);

      // Limpiar properties anteriores
      $tempForm.find('input[name^="properties[QO_"]').remove();

      // Agregar variantes adicionales como properties
      for (let i = 1; i < variants.length; i++) {
        const propInput = $(`<input type="hidden" name="properties[QO_Product_${i}]" value="${variants[i]}">`);
        $tempForm.append(propInput);
        console.log(`🚀 RELEASIT: Property agregada: QO_Product_${i} = ${variants[i]}`);
      }

      // Agregar al DOM
      $('body').append($tempForm);
      
      // Comunicar con Releasit
      const releasitInstance = window.RELEASIT || window.ReleasitCOD;
      if (releasitInstance && typeof releasitInstance.trackAddToCart === 'function') {
        try {
          variants.forEach((variantId, index) => {
            releasitInstance.trackAddToCart({
              variant_id: parseInt(variantId),
              quantity: 1
            });
            console.log(`🚀 RELEASIT: Notificando variante ${index + 1}: ${variantId}`);
          });
        } catch(e) {
          console.warn('🚀 RELEASIT: Error comunicando:', e);
        }
      }

      console.log("🚀 RELEASIT: Enviando formulario...");
      $tempForm.submit();
      return Promise.resolve();
    });
  }

  // Procesar variantes para Shopify
  function processVariantsForShopify(variants) {
    // Contar ocurrencias de cada variante
    const variantCounts = {};
    variants.forEach(id => {
      variantCounts[id] = (variantCounts[id] || 0) + 1;
    });

    // Crear items únicos con cantidades correctas
    const items = Object.keys(variantCounts).map(id => ({
      id: parseInt(id),
      quantity: variantCounts[id]
    }));

    console.log("🛒 SHOPIFY: Enviando items:", items);

    return $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: items })
    }).done(function(data) {
      console.log("✅ Productos agregados exitosamente:", data);
      
      // Limpiar tracking
      offerCartItems = [];
      
      // Redireccionar
      if (typeof timedRedirect === 'function') {
        timedRedirect();
      } else {
        window.location.href = '/cart';
      }
    }).fail(function(xhr) {
      console.error("❌ Error agregando al carrito:", xhr.responseText);
      throw new Error("Error agregando productos al carrito");
    });
  }

  // ========================================
  // EVENT LISTENERS (MODIFICADOS)
  // ========================================

  // Event listeners para opciones de cantidad
  $(document).on('change', 'input[name="quantity_offer"]', function() {
    const newQuantity = parseInt($(this).val());
    console.log("🔄 Cambio de cantidad:", selectedQuantity, "→", newQuantity);

    // Limpiar ofertas anteriores solo si hay variantes
    const clearPromise = hasRealVariants() ? clearAllOffers() : Promise.resolve();

    clearPromise.then(() => {
      selectedQuantity = newQuantity;
      
      console.log(`📊 Nueva cantidad seleccionada: ${selectedQuantity}`);
      console.log(`📊 Tipo de producto: ${hasRealVariants() ? 'Con variantes' : 'Sin variantes'}`);

      // Si no tiene variantes reales, actualizar cantidad inmediatamente
      if (!hasRealVariants()) {
        console.log("🔢 Producto sin variantes - actualizando cantidad del selector");
        updateQuantitySelector(selectedQuantity);
        
        // Ocultar selectores de variantes innecesarios
        $('#variantSelector2, #variantSelector3').hide();
        return;
      }

      // Para productos con variantes, mostrar selectores apropiados
      $('#variantSelector2').hide();
      $('#variantSelector3').hide();
      
      if (selectedQuantity === 2) {
        setTimeout(() => {
          $('#variantSelector2').show();
          console.log("📦 Mostrando selector para producto 2");
        }, 100);
      } else if (selectedQuantity === 3) {
        setTimeout(() => {
          $('#variantSelector3').show();
          console.log("📦 Mostrando selector para productos 2 y 3");
        }, 100);
      }

      console.log(`Estado actualizado - Cantidad: ${selectedQuantity}`);
    });
  });

  // Event listeners para inputs de opciones (solo para productos con variantes)
  $(document).on('change', 'input.option-input', function() {
    // Solo procesar si tiene variantes reales
    if (!hasRealVariants()) {
      console.log("🔢 Ignorando selección de opciones para producto sin variantes");
      return;
    }

    const $input = $(this);
    const $container = $input.closest('.variant-selector-container');
    
    // Validar que el contenedor esté visible y activo
    if (!$container.is(':visible')) {
      console.log("Ignorando evento de contenedor no visible");
      return;
    }
    
    const productPosition = $input.attr('data-product-position');
    const optionPosition = $input.attr('data-option-position');
    const value = $input.val();
    
    console.log(`📦 Opción seleccionada: Producto ${productPosition}, Opción ${optionPosition} = ${value}`);
    
    // Validar que el productPosition corresponda a la oferta activa
    const isOffer2 = selectedQuantity === 2 && productPosition === '2';
    const isOffer3Part2 = selectedQuantity === 3 && productPosition === '3_2';
    const isOffer3Part3 = selectedQuantity === 3 && productPosition === '3';
    
    if (isOffer2 || isOffer3Part2 || isOffer3Part3) {
      console.log(`📦 Procesando selección válida para oferta ${selectedQuantity}`);
      processOfferProductSelection(productPosition);
    } else {
      console.log(`📦 Ignorando selección inválida para oferta ${selectedQuantity}`);
    }
  });

  // MODIFICADO: Interceptor principal
  function setupFormInterceptor() {
    $('.product-form__add-button, .btn-primary-buy').each(function() {
      if (!$(this).data('original-text')) {
        $(this).data('original-text', $(this).text());
      }
    });

    $(document).on('click', '.product-form__add-button, .btn-primary-buy', function(e) {
      console.log("🔥 Click interceptado en botón");
      console.log("🔥 Cantidad seleccionada:", selectedQuantity);
      console.log("🔥 Tiene variantes:", hasRealVariants());

      // Solo interceptar si hay cantidad múltiple seleccionada
      if (selectedQuantity > 1 && !isProcessing) {
        console.log("🔥 Interceptando para cantidad múltiple");
        e.preventDefault();
        e.stopImmediatePropagation();
        
        try {
          processQuantityPurchase(selectedQuantity);
          
          // Si es producto sin variantes, el procesamiento actualiza la cantidad
          // y permite que el formulario continúe, así que necesitamos re-enviar
          if (!hasRealVariants()) {
            console.log("🔢 Re-enviando formulario con cantidad actualizada...");
            setTimeout(() => {
              isProcessing = false;
              $(this)[0].click(); // Re-enviar el click original
            }, 100);
          }
          
        } catch (error) {
          console.error("Error procesando cantidad múltiple:", error);
          isProcessing = false;
        }
        
        return false;
      } else {
        console.log("🔥 Permitiendo compra simple normal");
      }
    });

    $(document).on('click', '#clicar', function(e) {
      if (selectedQuantity > 1 && !isProcessing) {
        console.log("🔥 Interceptando botón flotante para cantidad múltiple");
        e.preventDefault();
        e.stopImmediatePropagation();
        
        try {
          processQuantityPurchase(selectedQuantity);
          
          if (!hasRealVariants()) {
            console.log("🔢 Re-enviando botón flotante con cantidad actualizada...");
            setTimeout(() => {
              isProcessing = false;
              $(this)[0].click();
            }, 100);
          }
          
        } catch (error) {
          console.error("Error procesando cantidad múltiple:", error);
          isProcessing = false;
        }
        
        return false;
      }
    });
  }

  // Event listeners para cerrar selectores
  $(document).on('click', '.close-variants-btn', function() {
    const targetId = $(this).data('target');
    console.log("Cerrando selector:", targetId);
    
    $('#' + targetId).hide();
    
    const clearPromise = hasRealVariants() ? clearAllOffers() : Promise.resolve();

    clearPromise.then(() => {
      $('input[name="quantity_offer"]').prop('checked', false);
      selectedQuantity = 1;
      $('#variantSelector2').hide();
      $('#variantSelector3').hide();
      
      // Resetear cantidad a 1
      updateQuantitySelector(1);
      
      console.log("Selector cerrado y estado completamente reseteado");
    });
  });

  // Compatibilidad con variantes del tema
  function ensureVariantCompatibility() {
    $(document).on('change', '.product-form__single-selector', function() {
      setTimeout(function() {
        const currentVariant = getCurrentVariantId();
        console.log("Variante actualizada por el tema:", currentVariant);
      }, 100);
    });
  }

  // ========================================
  // FUNCIONES DE DEBUG
  // ========================================

  window.debugQuantityOffers = function() {
    try {
      console.log("=== DEBUG QUANTITY OFFERS ===");
      console.log("Selected quantity:", selectedQuantity);
      console.log("Product variants count:", productVariants ? productVariants.length : 0);
      console.log("Has real variants:", hasRealVariants());
      console.log("Current variant ID:", getCurrentVariantId());
      console.log("Is Releasit form:", isReleasitForm());
      console.log("Is processing:", isProcessing);
      console.log("Offer selections:", offerSelections);
      console.log("Offer cart items:", offerCartItems);
      
      // Debug de inputs de cantidad
      const $qtyInputs = $('.qty, input[name="quantity"], .product-form__quantity input, [data-quantity-input]');
      console.log("Quantity inputs found:", $qtyInputs.length);
      $qtyInputs.each(function(i) {
        console.log(`  Input ${i}: ${this.tagName} class="${this.className}" name="${this.name}" value="${this.value}"`);
      });
      
      try {
        const $selectedRadio = $('input[name="quantity_offer"]:checked');
        console.log("Selected radio:", $selectedRadio.length ? $selectedRadio.val() : "none");
      } catch (e) {
        console.log("Selected radio: error accediendo");
      }
      
    } catch (error) {
      console.warn("Error en debugQuantityOffers:", error);
    }
  };

  window.clearOffers = function() {
    try {
      return clearAllOffers();
    } catch (error) {
      console.warn("Error en clearOffers:", error);
      return Promise.resolve();
    }
  };

  window.testQuantitySelector = function(qty) {
    try {
      if (!qty) qty = 3;
      console.log(`🧪 Testing quantity selector con cantidad: ${qty}`);
      selectedQuantity = qty;
      
      $('input[name="quantity_offer"]').prop('checked', false);
      $(`input[name="quantity_offer"][value="${qty}"]`).prop('checked', true);
      
      const success = updateQuantitySelector(qty);
      console.log("🧪 Resultado:", success ? "✅ Éxito" : "❌ Falló");
      console.log("🧪 Tipo de producto:", hasRealVariants() ? "Con variantes" : "Sin variantes");
    } catch (error) {
      console.warn("Error en testQuantitySelector:", error);
    }
  };

  // ========================================
  // INICIALIZACIÓN PRINCIPAL
  // ========================================

  function initializeQuantityOffers() {
    try {
      console.log("🚀 Inicializando sistema de ofertas con selector de cantidad");
      
      // Cargar datos del producto
      const dataLoaded = loadProductData();
      if (!dataLoaded) {
        console.warn("⚠️ No se pudieron cargar datos del producto, continuando...");
      }
      
      // Configurar event listeners
      setupFormInterceptor();
      ensureVariantCompatibility();
      
      // Configurar detección de RSI
      setupMinimalRSIDetection();
      
      selectedQuantity = 1;
      
      console.log("✅ Sistema inicializado correctamente");
      console.log("- Variantes cargadas:", productVariants ? productVariants.length : 0);
      console.log("- Tiene variantes reales:", hasRealVariants());
      console.log("- Sistema detectado:", isReleasitForm() ? "🚀 Releasit/RSI" : "🛒 Shopify");
      
      console.log("\n🛠️ Funciones disponibles:");
      console.log("  debugQuantityOffers()     - Debug completo");
      console.log("  clearOffers()             - Limpiar ofertas");
      console.log("  testQuantitySelector(qty) - Probar selector de cantidad");
      
      if (!hasRealVariants()) {
        console.log("\n🔢 PRODUCTO SIN VARIANTES DETECTADO:");
        console.log("- 🔢 Usa selector de cantidad nativo");
        console.log("- 🔢 No requiere selección de variantes");
        console.log("- 🔢 Cantidad se actualiza automáticamente");
      } else {
        console.log("\n📦 PRODUCTO CON VARIANTES DETECTADO:");
        console.log("- 📦 Requiere selección de variantes");
        console.log("- 📦 Muestra selectores adicionales");
      }
      
      // Debug inicial
      const $qtyInputs = $('.qty, input[name="quantity"], .product-form__quantity input, [data-quantity-input]');
      console.log(`🔢 Inputs de cantidad encontrados: ${$qtyInputs.length}`);
      
      return true;
    } catch (error) {
      console.error("❌ Error inicializando sistema de ofertas:", error);
      return false;
    }
  }

  // Ejecutar inicialización
  console.log("🚀 Ejecutando inicialización...");
  if (initializeQuantityOffers()) {
    console.log("✅ Inicialización completada exitosamente");
  } else {
    console.warn("⚠️ Inicialización completada con errores");
  }

}); // Fin del document ready

// ========================================
// EJECUCIÓN PRINCIPAL DEFENSIVA
// ========================================

function initQuantityOffers() {
  // El código ya está envuelto en $(document).ready
}

// Intentar ejecutar inmediatamente si jQuery ya está disponible
if (typeof $ !== 'undefined' && typeof jQuery !== 'undefined' && document.readyState === 'complete') {
  console.log("Ejecutando inmediatamente - jQuery y DOM listos");
  setTimeout(initQuantityOffers, 100);
} else {
  console.log("Esperando a que jQuery y DOM estén listos...");
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log("DOM cargado, esperando jQuery...");
      setTimeout(initQuantityOffers, 500);
    });
  }
  
  window.addEventListener('load', function() {
    console.log("Window load event - ejecutando con retraso...");
    setTimeout(initQuantityOffers, 1000);
  });
  
  let attempts = 0;
  const maxAttempts = 30;
  
  const pollForReadiness = setInterval(function() {
    attempts++;
    
    if (typeof $ !== 'undefined' && typeof jQuery !== 'undefined' && document.readyState === 'complete') {
      console.log(`jQuery y DOM listos después de ${attempts} intentos`);
      clearInterval(pollForReadiness);
      setTimeout(initQuantityOffers, 300);
    } else if (attempts >= maxAttempts) {
      console.warn("Timeout esperando jQuery/DOM - ejecutando de todos modos");
      clearInterval(pollForReadiness);
      
      if (typeof $ !== 'undefined') {
        setTimeout(initQuantityOffers, 500);
      } else {
        console.error("jQuery nunca se cargó - sistema de ofertas no disponible");
      }
    }
  }, 500);
}